import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27cde33b"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "indicator_wrap" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "indicator_rec" })
], -1))
const _hoisted_2 = { class: "stock_top_info" }
const _hoisted_3 = { class: "title_24B" }
const _hoisted_4 = {
  key: 0,
  class: "main_14R"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 엔젤리그 투자자의 관심을 가장 많이 받은 회사")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 파란별로 관심표시 하면, 홈에서 모아볼 수 있어요! ")
const _hoisted_8 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "main_14R"
}
const _hoisted_10 = { class: "stock_top_rank" }
const _hoisted_11 = { class: "row vote_row" }
const _hoisted_12 = { class: "space-between" }
const _hoisted_13 = { class: "entire_company_left" }
const _hoisted_14 = { class: "rank_idx" }
const _hoisted_15 = { class: "c_logo" }
const _hoisted_16 = ["src"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inset-border" }, null, -1))
const _hoisted_18 = { class: "right-space-between" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "list_17M" }
const _hoisted_21 = { class: "right_bottom" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "star_n",
  src: "/assets/icon/star_n.png"
}, null, -1))
const _hoisted_23 = { class: "main_13R" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin":"0px 8px","color":"#D9DEE8","font-size":"10px"} }, "|", -1))
const _hoisted_26 = { class: "charcoal" }
const _hoisted_27 = { class: "right_bottom" }
const _hoisted_28 = {
  key: 0,
  class: "charcoal"
}
const _hoisted_29 = { class: "ion-activatable ripple-parent star_padding" }
const _hoisted_30 = ["disabled", "onClick"]
const _hoisted_31 = {
  key: 0,
  class: "star",
  src: "/assets/icon/star_b.png"
}
const _hoisted_32 = {
  key: 1,
  class: "star",
  src: "/assets/icon/star_g.png"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.viewTitle) + " TOP50 ", 1),
      (_ctx.viewType === 'default')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_8))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, " 엔젤리그에서 최근 일주일동안 많이 검색된 회사 "))
    ]),
    _createVNode(_component_ion_content, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.viewType === 'default' ? _ctx.stockItemTop50(_ctx.stockItems) : _ctx.popularItemTop50(_ctx.stockItems), (stock, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                key: (stock, idx),
                class: "entire_company"
              }, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, _toDisplayString(idx+1), 1),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("img", {
                        src: stock.companyLogo ? stock.companyLogo : '/assets/icon/company_default_img.png',
                        onerror: "this.src='/assets/icon/company_default_img.png'",
                        class: "img-responsive img-circle"
                      }, null, 8, _hoisted_16),
                      _hoisted_17
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", {
                      class: "entire_company_right",
                      onClick: ($event: any) => (_ctx.useCompanyModal(stock.stockItemId))
                    }, [
                      _createElementVNode("div", _hoisted_20, _toDisplayString(stock.stockItemName), 1),
                      _withDirectives(_createElementVNode("div", _hoisted_21, [
                        _hoisted_22,
                        _createElementVNode("span", _hoisted_23, _toDisplayString(stock.likeCount) + "명", 1),
                        (stock.minSellingPrice)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                              _hoisted_25,
                              _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$filters.currency(stock.minSellingPrice)) + " 원 ", 1)
                            ]))
                          : _createCommentVNode("", true)
                      ], 512), [
                        [_vShow, _ctx.viewType === 'default']
                      ]),
                      _withDirectives(_createElementVNode("div", _hoisted_27, [
                        (stock.minSellingPrice)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.$filters.currency(stock.minSellingPrice)) + " 원 ", 1))
                          : _createCommentVNode("", true)
                      ], 512), [
                        [_vShow, _ctx.viewType === 'popular']
                      ])
                    ], 8, _hoisted_19),
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("button", {
                        disabled: ~['mna','ipo'].indexOf(stock.companyStatus),
                        onClick: ($event: any) => (_ctx.user === null ? _ctx.$global.openLoginModal() :_ctx.itemLike(stock.stockItemId))
                      }, [
                        (stock.likeFlag)
                          ? (_openBlock(), _createElementBlock("img", _hoisted_31))
                          : (_openBlock(), _createElementBlock("img", _hoisted_32))
                      ], 8, _hoisted_30),
                      _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                    ])
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _: 1
    })
  ], 64))
}